<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>REGISTRATION</p>
      </div>
    </div>
    <div class="main-container">
      <div class="content-item-grp"  v-show="false">
        <div class="content-item">
          <div class="item-title">
            <!-- <span class="item-title-content">REGISTRATION</span> -->
          </div>
          <div class="item-content" style="text-align: left;" v-show="false">
            <div class="info-content">
              <div class="item-title">
                <span class="item-title-content">关于【强烈谴责倒卖大会注册名额行为】的声明</span>
              </div>
              <p>近期组委会发现在淘宝、咸鱼等多个平台出现贩卖VALSE 2026大会注册名额的情况，严重影响有意愿参与大会的老师同学正常注册。组委会对此强烈谴责，并坚决抵制此类行为。</p>
              <p>VALSE旨在为中国青年学者提供一个深层次学术交流的舞台。大会组委会尽力为大家提供一个优质学术交流环境和公平的参会机会。由于会场容量和服务能力有限，不得已限量注册人数。贩卖大会注册名额的行为严重破坏了大会的初衷，严重影响大会注册秩序，给参会者带来困扰，也给大会组织带来恶劣影响。</p>
              <p>为杜绝此类情况发生，组委会制定如下举措：</p>
              <div class="info-list">1. 强烈谴责倒卖大会注册名额的行为，组委会将与各电商平台沟通交涉处理。</div>
              <div class="info-list">2. 已经完成第一轮注册的参会人员，姓名，单位，手机号等个人信息均不能更改。本通知发出后将开放系统（注册地址：<a href="https://valser.org/reg/2026" target="_blank" class="reg-link">https://valser.org/reg/2026</a>），请已预注册人员务必在<b>【2026年4月27日23点前】</b>补充提交身份证信息。未按时完成信息补充将取消参会资格。</div>
              <div class="info-list">3. VALSE 2026大会注册现场将查验身份证件，确保人、证、注册信息一致方可参会。</div>
              <div class="info-list">4. 第二轮预注册将放出足额参会名额，请大家关注第二轮预注册，及时注册。</div>
              <p>最后呼吁大家支持VALSE 2026，不购买"黄牛票"，共同维护我们VALSE的良好环境。</p>
              <p>再次感谢大家对VALSE的支持和信任！期待与您在珠海相聚，共享年度盛宴！</p>
              <p>VALSE 2026组委会</p>
            </div>
          </div>
          <div class="item-content" style="text-align: left;" v-show="false">
          <p>按照预定计划，我们在4月21日15点开启了VALSE 2026的第一轮预注册，3500位预注册名额在65秒内注册完毕，感谢各位对VALSE大会长期的信赖和支持。</p>
          <p>组委会现公布第二轮预注册和确认参会计划，如下：</p>
                
                <div class="info-list">(1). 第二轮预注册开启时间: <b><font color="#f00000">2026年5月12日 15:00:00</font></b></div>
                <div class="info-list">(2). 正式确认参会起止时间: <b><font color="#f00000">2026年5月20日 09:00:00至2023年5月22日 23:59:59</font></b></div>
                
                <p>注册地址：<a href="https://valser.org/reg/2026" target="_blank" class="reg-link">https://valser.org/reg/2026</a></p>
                
                <p>为确保您能正常参会，请务必仔细阅读：</p>
                
                <div class="info-list">(1). 未预注册成功的参会人员，请务必于<b>【第二轮预注册开启的第一时间完成预注册】</b>。</div>
                
                <div class="info-list">(2). 第一轮和第二轮预注册成功的参会人员请务必于确认参会起止时间内尽快在注册系统中完成<b>【正式参会确认】</b>，完成正式参会确认者才会被视为成功获得VALSE 2026参会资格，未按时完成确认参会者将取消参会资格，且未获得参会资格的人员将无法进入会场。</div>
                
                <div class="info-list">(3). 如您确定不参会，请第一时间在注册系统中取消注册，以便给他人提供参会机会。</div>
                
                <div class="info-list">(4). 为保障更多有意参会的老师和同学能够获得名额，参会资格不得转让他人，<b><font color="#f00000">且预注册成功后，注册手机号将无法修改。</font></b></div>

                <p style="text-align: left;">感谢大家对VALSE的支持和信任！期待与您在珠海相聚，共享视觉与学习年度盛宴！</p>
                <p style="text-align: left;">VALSE 2026组委会</p>
        </div>
          <div class="item-content" style="text-align: left;" v-show="false">
            
            <p>为确保您能正常参会，请务必仔细阅读以下注意事项：</p>
            <div class="info-list">(1). <b><font color="#f00000">2026年4月21日 15:00:00</font></b>将开放参会预注册。注册地址：<a href="https://valser.org/reg/2026" target="_blank"  type="primary">https://valser.org/reg/2026</a></div>
            <div class="info-list">(2). 注册系统需要通过手机短信进行验证，由于会场要求，<b><font color="#f00000">请务必填写与您身份证件完全一致的姓名，若注册姓名与证件姓名不一致，</font></b>届时将无法进入会场参会。</div>
            <div class="info-list">(3). 注册信息提交后，需根据系统提示<b>设置密码</b>（用于后续登录），并<b>填写拟参加的Workshop和Tutorial</b>，以便会务组合理安排会议室，请您提前准备好。<b>并继续填写订餐意向，便于用餐安排。</b></div>
            <div class="info-list">(4). 您参会预注册成功后，<b><font color="#f00000">仍需要关注后续确认参会的通知</font></b>，该通知将在VALSE微信公众号和网站发布。完成正式参会确认，才会被视为成功完成VALSE 2026参会注册，未按时完成确认者将无法参会。</div>
            <div class="info-list"><font color="#f00000">特别提醒：</font>为保障更多有意参会的老师和同学能够获得名额，参会资格不得转让他人，<b><font color="#f00000" style="text-decoration: underline;">且预注册成功后，注册手机号将无法修改。</font></b>如果确认参会后有名额剩余，组委会将根据确认参会人数的情况，适时开放一定数量的参会名额。</div>
            <p style="text-align: left;">感谢大家对VALSE的支持和信任！期待与您在珠海相聚，共享视觉与学习年度盛宴！</p>
            <p style="text-align: left;">VALSE 2026组委会</p>
          </div>
        </div>
      </div>
      <div class="content-item-grp"  v-show="false">
        <!-- <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">VALSE 2026【确认参会】通知</span>
          </div>
        
          <div class="item-content">
            <div class="info-content">
            

              <p>
                <b>现已开启正式参会确认，该通道将在2026年5月22日23:59:59关闭。<br/>
                  参会确认网址：<a href="https://valser.org/reg/2026" target="_blank" class="reg-link">https://valser.org/reg/2026</a></b>
              </p>
              <div class="info-list">为确保您能正常参会，请务必仔细阅读以下三条注意事项：</div>
              <div class="info-list">1. 第一轮和第二轮预注册成功的参会人员请务必于<font color='FF000'>5月22日23:59:59前</font>在注册系统中完成【正式参会确认】，完成正式参会确认者才会被视为成功获得VALSE 2026参会资格。</div>
              <div class="info-list">2. 5月22日23:59:59前未完成确认参会者将取消参会资格，且未完成线上参会确认的老师和同学不允许现场注册且肯定不能进入会场。</div>
              <div class="info-list">3. 如您确定不参会，请第一时间在注册系统中取消注册，以便组委会统筹。</div>
            </div>
          </div>
        </div> -->
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">VALSE 2026【现场参会】通知</span>
          </div>
        
          <div class="item-content">
            <div class="info-content">
            

              <p>
                <b>现场签到二维码将以短信形式已发送，请注意查收，并截图保存，若未收到短信或被拦截，请在注册系统中查看。<br/>
                  网址：<a href="https://valser.org/reg/2026" target="_blank" class="reg-link">https://valser.org/reg/2026</a></b>
              </p>
              <p>签到时间：6月5日14:00 - 18:00 至 6月6日07:00 - 10:00</p>

              <p>综合自助签到时间：6月6日10:10 至 6月7日12:00</p>

              <p>签到地点：珠海国际会展中心C座C1门一层</p>

              <div class="info-list">现场签到注意事项：</div>
              <div class="info-list">1.请务必截图并妥善保存本凭证。现场签到时提前打开本凭证和有效身份证件，核验通过后领取参会证和会议材料;</div>
              <div class="info-list">2. 强烈建议您在6月5日14:00-20:00间到会场签到处提前完成现场签到，避免因6日人数拥堵而影响您正常参会;</div>
              <div class="info-list">3. 当现场签到通道拥堵时，组委会将以此凭证作为暂时入场凭证，待现场签到通道畅通时务必完成现场签到。</div>
            </div>
          </div>
        </div>
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">VALSE 2026【线上订餐】通知</span>
          </div>
        
          <div class="item-content">
            <div class="info-content">
              <p>本次大会预计参会总人数将超过5000人，由于大会举办地珠海国际会展中心周边餐饮服务在同一时间段的承载能力有限（不足600人）。为切实保障参会人员用餐需求，经组委会慎重研究决定，由参会者自行向珠海国际会展中心自愿选择性预定，并将相应金额的餐费直接支付给会展中心，餐费发票由会展中心开具并发送到参会者预留邮箱。在此过程中，VALSE组委会及会务服务公司不涉及任何财务收支事项。
              </p><p><b>预定地址：<a href="https://hzzx.5hui.cn<" target="_blank" class="reg-link">https://hzzx.5hui.cn</a></b>  需在电脑端或者复制链接到微信/支付宝打开预定，并按照提示填写信息、支付以及申请发票。
                
              </p>
              <div class="info-list">线上订餐注意事项：</div>
              <div class="info-list">1. 完成确认参会后方可订餐，预定截止时间：2026年5月22日23:59:59。</div>
                <div class="info-list">  2. 珠海国际会展中心提示：每餐两荤一素，餐费支付成功后，餐费一律不退。</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="content-item-grp"  v-show="false">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">关于现场签到的相关说明</span>
          </div>
          <div style="text-align: center;">
            <img style="width: 60%;" src="../../static/images/huichangbuju.jpg" />

          </div>
          <div class="item-content">
            <div class="info-content">
            

              <p>
                <b>签到地点与时间</b>
              </p>
              <div class="info-list">1. 重庆悦来国际会议中心1号门VALSE签到处</div>
              <div class="info-list">时间: 5月4日14:00-20:00，5月5日07:00-18:00，5月6日08:00-18:00，5月7日08:00-12:00</div>
              <!-- <div class="info-list">2.	无锡君来世尊酒店-酒店大堂</div>
              <div class="info-list">时间：6月9日13:00-20:00</div>
              <div class="info-list">3. 无锡太湖新城假日酒店-酒店大堂</div>
              <div class="info-list">时间：6月9日13:00-20:00</div> -->
              <p><b>签到方式</b></p>
              <div class="info-list">1. 请提前打开签到二维码用于现场签到，核验通过后领取参会证和会议材料</div>
              <div class="info-list">2. 强烈建议您在<b>5月4日14点-18点间到会场签到处提前完成现场签到</b>，避免因开幕式（5日）早上人数拥堵而影响您正常参会；</div>
              <div class="info-list">3. 当现场签到通道拥堵时，组委会将以签到二维码作为暂时入场凭证，待现场签到通道畅通时务必完成现场签到。</div>
              <p><b>签到二维码获取方式</b></p>
              <div class="info-list">组委会将在2024年4月29日向已正式确认参会者以手机短信形式发送现场签到二维码链接，获取现场签到二维码并截图保存</div>
              <div class="info-list">在4月30日后登录VALSE2024注册网站<font color='FF000'><a  target="__blank" href="http://valser.org/reg/2024"> http://valser.org/reg/2024</a></font>点击获取注册二维码。</div>
              <p><b>特别提醒：会议不设现场注册通道，未完成正式确认参会将不允许入场。</b></p>
            </div>
          </div>
        </div>
      </div>
      <div class="content-item-grp"  v-show="true">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">关于大会相关问题说明</span>
          </div>
          <div class="item-content" >
            <!-- <p class="content-null-info">敬请期待......</p> -->
            <div class="info-list" style="text-align:left;">近期VALSE邮箱和公众号以及组委会老师邮箱收到大量与VALSE 2026大会相关的咨询信息，因时间问题无法一一回复，望各位理解。现就大家比较关注的几个问题，组委会做出统一说明，如下：</div>
            <div class="info-title" style="text-align:left;">
              1. 关于现场签到和参会的说明
            </div>
            <div class="info-content">
              <!-- 第一次预注册成功参会人员请务必于<b>2022年8月16日18:00之前在<a href="http://valser.org/reg/2022">注册系统 (http://valser.org/reg/2022)</a>中完成正式参会确认</b>，才会被视为成功完成VALSE 2022参会注册，未按时完成确认者将取消参会资格。如确定不参会，也请在系统中完成取消参会的确认，以方便我们及时统计参会情况。 -->
              <div class="info-list">
                <div>（1）目前预注册参会人数已达会场报备容量，预注册参会通道已关闭。</div>
                <!-- <div>（1）目前预注册参会人数已达会场报备容量，预注册参会通道已关闭，<font color='FF000'><b>VALSE2026大会不接受现场注册，未能完成参会确认的人员请勿到会，以免给您带来不便。</b></font></div> -->
                <div>（2）<font color='FF000'><b>注册名额和签到凭证不能转让，非本人签到凭证和参会胸牌将不允许入场。签到凭证获取方式后续会通知。</b></font></div>
                <!-- <div>（3）<b>第一次预注册成功，但现在无法确认参会，是因为没有按照VALSE公众号通知以及短信通知，在2026年4月27日23点前补充提交身份证信息，系统自动取消参会资格。</b>通知地址：<a href="https://mp.weixin.qq.com/s/1vWxiXAX-UaxX_D7WjBh6g" target="_blank" class="reg-link">https://mp.weixin.qq.com/s/1vWxiXAX-UaxX_D7WjBh6g</a></div> -->
                
              </div>
            </div>
            <div  v-show="false">

            <div class="info-title" style="text-align:left;">
              2. 已完成正式确认参会，但未接到签到二维码短信
            </div>
            <div class="info-content">
              <div class="info-list">
                <!-- （1）如果<font color='FF000'><b>已按时完成确认参会</b></font>，请登录注册系统<font color='FF000'><a  target="__blank" href="http://valser.org/reg/2024"> http://valser.org/reg/2024</a></font>，按照提示点击获取注册二维码并截图保存。 -->
                （1）如果<font color='FF000'><b>已按时完成确认参会</b></font>，请在2026年5月31日前注意短信通知，按照提示点击获取注册二维码并截图保存。
              </div>
            </div>
          </div>

            <div class="info-title" style="text-align:left;">
              2.	是否有线上直播或回放
            </div>
            <div class="info-content">
              <!-- 第一次预注册成功参会人员请务必于<b>2022年8月16日18:00之前在<a href="http://valser.org/reg/2022">注册系统 (http://valser.org/reg/2022)</a>中完成正式参会确认</b>，才会被视为成功完成VALSE 2022参会注册，未按时完成确认者将取消参会资格。如确定不参会，也请在系统中完成取消参会的确认，以方便我们及时统计参会情况。 -->
              <div class="info-list" >
                <div>（1）受会场网络限制，<font color='FF000'><b>大会不支持线上直播</b></font>。大会视频暂未确定是否开放，如果开放会在公众号发送通知。</div>
                （2）为保护大会讲者权益，<font color='FF000'><b>大会各个报告可以拍照，但不允许个人或团体直播或录制。</b></font>期间会有志愿者巡查，对于不听劝阻者将被取消参会资格。
              </div>

            </div>
            <div class="info-title" style="text-align:left;">
              3.	会议通知和邀请函相关
            </div>
            <div class="info-content">
              <div class="info-list" >
                <!-- <div>（1）组委会公布VALSE 2026会议通知，<a target='_blank' href='./static/VALSE2026_HYTZ.pdf' class='news-item'>点击此处下载</a>。<font color='FF000'><b>该会议通知等同于会议邀请函，不面向个人提供定制的会议邀请函。</b></font></div> -->
                （1）会议通知将在4月21日左右在网站发布，届时请下载。
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="content-item-grp" v-show="false">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">
              第二次预注册安排
            </span>
          </div>
          <div class="item-content" >
            <!-- <p class="content-null-info">敬请期待......</p> -->
            <!-- <div class="info-title">
              <p>组委会计划在<b>2024年4月20日</b>开放参会预注册，具体注册安排和网址请关注VALSE微信公众号通知。</p>
              <p>扫码关注VALSE微信公众号</p>
              <img src="static/images/valse_wechat.jpg"/>
            </div> -->
            <div class="info-content" v-show="false">
              <p>
                VALSE 2024大会将于
                <b><font color="#f00000">2024年6月10-12日</font></b>在<b>无锡</b>举办。届时将延续历年传统，呈上5个大会特邀报告、12个APR报告、4场Tutorial、20场Workshop、200+篇顶会顶刊Poster，合计共有百余位知名青年学者共同带来CVPR、ML领域的又一次学术盛宴。本年VALSE大会一如既往的不收注册费。欢迎大家及时报名参加，一起畅舞优美的"视觉与学习"学术华尔兹。
              </p>
              <p>为确保您能正常参会，请务必仔细阅读以下四条注意事项：</p>
              <div class="info-list">(1). <b><font color="#f00000">2024年4月20日 15:00:00</font></b>将开放参会预注册。</div>
                <div class="info-list">(2). 注册系统需要通过手机短信进行验证，由于会场要求，<b><font color="#f00000">请务必填写与您身份证件完全一致的姓名，</font></b>否则届时将无法进入会场参会。</div>
                <!-- <div class="info-list">(3). 您参会预注册成功后，还需要在<b><font color="#f00000">2022年7月19日-7月20日</font></b>期间在注册系统中完成正式参会确认，才会被视为成功完成VALSE 2024参会注册，未按时完成确认者将无法参会。</div> -->
                

                <!-- <div class="info-list">(4). 由疫情防控原因导致您完成（3）确认参会而无法前往的，组委会则不会将您记入参会黑名单。如完成确认参会，但无故不参会，则会记入黑名单。</div> -->
                <div class="info-list">(3). 注册信息提交后，需根据系统提示<b>设置密码</b>（用于后续登录），并<b>填写拟参加的Workshop和Tutorial</b>，以便会务组合理安排会议室，请您提前准备好。点击查看<el-link href="http://valser.org/2024/#/workshop" target="_blank"  type="primary">Workshop</el-link>和<el-link href="http://valser.org/2024/#/tutorial" target="_blank"  type="primary">Tutorial</el-link>详情。</div>
                <div class="info-list">(4). 您参会预注册成功后，<b><font color="#f00000">仍需要关注后续确认参会的通知，</font></b>该通知将在VALSE微信公众号和网站发布。完成正式参会确认，才会被视为成功完成VALSE 2024参会注册，未按时完成确认者将无法参会。</div>
                <!-- (5). 若您属于后附定义的VIP，请不要在此注册， -->
                <p>感谢大家对VALSE的支持和信任！期待与您在无锡相聚，共享视觉与学习年度盛宴！</p>
                    <p>VALSE 2024组委会</p>
            </div>
            <div class="info-content">
              <p>
              VALSE 2024大会将于
              <b><font color="#f00000">2024年6月10-12日</font></b>在<b>无锡</b>举办。届时将延续历年传统，呈上5个大会特邀报告、12个APR报告、4场Tutorial、20场Workshop、200+篇顶会顶刊Poster，合计共有百余位知名青年学者共同带来CVPR、ML领域的又一次学术盛宴。本年VALSE大会一如既往的不收注册费。欢迎大家及时报名参加，一起畅舞优美的"视觉与学习"学术华尔兹。
            </p>
            <p>按照预定计划，我们在4月20日15点开启了VALSE 2024的第一轮预注册，3000位预注册名额在1小时内注册完毕，注册速度创历史最高记录，感谢各位对VALSE大会长期的信赖和支持。</p>
                <p>组委会现公布第二轮预注册和确认参会计划，如下：</p>
                <div class="info-list">(1).  第二轮预注册开启时间: <b><font color="#f00000">2024年5月5日 15:00:00</font></b></div>
                <div class="info-list">(2).  正式确认参会起止时间: <b><font color="#f00000">2024年5月20日 09:00:00至2024年5月22日 23:59:59</font></b></div>
                <p>为确保您能正常参会，请务必仔细阅读：</p>
                <div class="info-list">(1).受会场容量限制，第二轮预注册名额上限为2000人，未预注册成功的参会人员，请务必于<b>【第二轮预注册开启的第一时间完成预注册】</b>。如无特殊情况，第二轮预注册满额后，组委会将不再开启预注册通道。</div>
                <div class="info-list">(2).第一轮和第二轮预注册成功的参会人员请务必于确认参会起止时间内尽快在注册系统中完成<b>【正式参会确认】</b>，完成正式参会确认者才会被视为成功获得VALSE 2024参会资格，未按时完成确认参会者将取消参会资格，且未获得参会资格的人员将无法进入会场。</div>
                <div class="info-list">(3).如您确定不参会，请第一时间在注册系统中取消注册，以便给他人提供参会机会。</div>
                <!--<div class="info-list">(1). <b><font color="#f00000">2024年4月20日 15:00:00</font></b>将开放参会预注册。</div>
                    <div class="info-list">(2). 注册系统需要通过手机短信进行验证，由于会场要求，<b><font color="#f00000">请务必填写与您身份证件完全一致的姓名，</font></b>否则届时将无法进入会场参会。</div>
                    <div class="info-list">(3). 您参会预注册成功后，还需要在<b><font color="#f00000">2022年7月19日-7月20日</font></b>期间在注册系统中完成正式参会确认，才会被视为成功完成VALSE 2024参会注册，未按时完成确认者将无法参会。</div> 
                    
            
                    <div class="info-list">(4). 由疫情防控原因导致您完成（3）确认参会而无法前往的，组委会则不会将您记入参会黑名单。如完成确认参会，但无故不参会，则会记入黑名单。</div> 
                    <div class="info-list">(3). 注册信息提交后，需根据系统提示<b>设置密码</b>（用于后续登录），并<b>填写拟参加的Workshop和Tutorial</b>，以便会务组合理安排会议室，请您提前准备好。点击查看<el-link href="http://valser.org/2024/#/workshop" target="_blank"  type="primary">Workshop</el-link>和<el-link href="http://valser.org/2024/#/tutorial" target="_blank"  type="primary">Tutorial</el-link>详情。</div>
                    <div class="info-list">(4). 您参会预注册成功后，<b><font color="#f00000">仍需要关注后续确认参会的通知，</font></b>该通知将在VALSE微信公众号和网站发布。完成正式参会确认，才会被视为成功完成VALSE 2024参会注册，未按时完成确认者将无法参会。</div>-->
                <p>感谢大家对VALSE的支持和信任！期待与您在无锡相聚，共享视觉与学习年度盛宴！</p>
                  <p>VALSE 2024组委会</p>
                  </div>
                </div>
          <div class="item-content"  v-show="true">
            <!-- <p class="content-null-info">敬请期待......</p> -->
            <div class="info-title">
              关于现场注册的相关说明
            </div>
            <div class="info-content">
              <p>
                <b>注册地点与时间</b>
              </p>
              <div class="info-list">1. 无锡太湖国际博览中心B馆1层VALSE签到处</div>
              <!-- <div class="info-list">时间: 6月9日13:00-17:00，6月10日07:30-18:00，6月11日08:00-18:00，6月12日08:00-14:00</div>
              <div class="info-list">2.	无锡君来世尊酒店-酒店大堂</div>
              <div class="info-list">时间：6月9日13:00-22:00</div>
              <div class="info-list">对象：普通参会人员和入住该酒店的VIP</div>
              <div class="info-list">3. 天津宝盛道谷酒店（钱江世纪城民和路800号3号楼D入口）-酒店大堂</div>
              <div class="info-list">时间：10月7日13:00-22:00</div>
              <div class="info-list">对象：普通参会人员和入住该酒店的VIP</div>
              <div class="info-list">4.	天津瑞立江河汇酒店（江干区之江路1299号）-酒店大堂</div>
              <div class="info-list">时间：10月7日13:00-22:00</div>
              <div class="info-list">对象：普通参会人员</div>
              <div class="info-list">5.	天津奥体中心和昌希尔顿欢朋酒店（滨江区飞虹路208号）-酒店大堂</div>
              <div class="info-list">时间：10月7日13:00-22:00</div>
              <div class="info-list">对象：普通参会人员</div> -->
              <p><b>注册方式</b></p>
              <div class="info-list">1. 请提前打开签到二维码用于现场签到，核验通过后领取参会证和会议材料</div>
              <div class="info-list">2. 强烈建议您在<b>6月9日13点-17点间到会场签到处提前完成现场签到</b>，避免因10日人数拥堵而影响您正常参会；</div>
              <div class="info-list">3. 当现场签到通道拥堵时，组委会将以签到二维码作为暂时入场凭证，待现场签到通道畅通时务必完成现场签到。</div>
              <p><b>注册二维码获取方式</b></p>
              <div class="info-list">登录VALSE2024注册网站<font color='FF000'><a  target="__blank" href="http://valser.org/reg/2022"> http://valser.org/reg/2022</a></font>点击获取注册二维码。</div>
              <!-- <p><b>注册其他事项</b></p>
              <div class="info-list">1. 您可先凭备用入场凭证（登录VALSE2022注册网站获取）进入会场，然后在休息或者其他时间再进行注册领取资料；</div>
              <div class="info-list">2. 考虑到与会人员众多，如果您离会场或会议指定酒店较近，建议您尽量在10月7日完成注册； 10月8日进行注册的，请您合理安排到场时间进行注册。</div> -->
              <!-- <div class="info-list"></div>
              <div class="info-list"></div>
              <div class="info-list"></div>
              <div class="info-list"></div>
              <div class="info-list"></div> -->
            <!-- <p>
              VALSE 2022大会将于<b><font color="#f00000">2022年10月8-10日</font></b>在天津举办，届时将延续历年传统，呈上8个大会特邀报告、10个APR报告、4场Tutorial、14场Workshop、150+篇顶会顶刊Poster，合计共有百余位知名青年学者共同带来CVPRML领域的又一次学术盛宴。今年恰逢<b>VALSE十周年</b>，大会特邀了<b>徐宗本院士</b>做主旨演讲，并将组织小型特别纪念活动。本年VALSE大会一如既往的<b>不收注册费</b>。欢迎大家及时报名参加，一起畅舞优美的"视觉与学习"学术华尔兹。
            </p>
            <p>第一次预注册成功参会人员请务必于2022年9月16日18:00-9月19日18:00期间在注册系统中完成正式参会确认，才会被视为成功完成VALSE 2022参会注册，未按时完成确认者将取消参会资格。如确定不参会，也请在系统中完成取消参会的确认，以方便我们及时统计参会情况。</p>
            <p>关于第二次预注册，组委会确定了以下原则：</p>

            <div class="info-list">(1).  确保VIP (VIP定义请见后附)可成功注册，注册通道另行通知；</div>
            <div class="info-list">(2). 确保Poster/Spotlight文章的讲者可成功注册；</div>
            
            <div class="info-list">(3). 确保承诺给赞助商的参会名额；</div>
            <div class="info-list">(4). 给予VALSE各组委会、AC委员每人若干推荐他人参会的名额；</div>
            <div class="info-list">(5). 给予曾对VALSE有过贡献的人员更多参会机会；</div>
            <div class="info-list">(6). 给予教师、博士后、博士生以更多的参会机会；</div>
            <div class="info-list">(7). 第一次已预注册人员，只要按要求在规定时间内完成确认，就可以获得参会资格；</div>
            <div class="info-list">(8). 注册名额不得转让，只能确认参会或取消注册；</div>
            <div class="info-list">(9). 已预注册人员，若确定不参会，应第一时间取消预注册；</div>
            <div class="info-list">(10).  对确认了参会但最终没有签到参会的人员，明年VALSE的参会申请将被拒绝。</div>
            <p>基于以上原则，决定对后续注册方案及确认流程做如下调整:</p>
            <div class="info-list">(1).  2022年9月20日08:00-9月24日24:00，将持续5天开放第二轮预注册（不限额）。 鉴于所剩名额已较少，而且这些名额主要分配给VIP、Poster展示人员、长期参加VALSE的老师等人员，强烈建议您先评估自己是否能获得参会资格再进行预注册。<b><font color='FF000'>预注册网址：http://valser.org/reg/2022</font></b></div>
            <div class="info-list">(2). 除附件定义的VIP之外，其他所有有意参会人员(包括第一次未注册成功的Poster/Spotlight讲解作者，也包括赞助企业普通参会名额)均需通过上述通道进行预注册。</div>
            
            <div class="info-list">(3). 第二轮预注册结束后，组委会将在9月26日前遴选数百名参会人员，遴选依据参见上述第2、3、4、5、6条原则。</div>
            <div class="info-list">(4). 第二次预注册人员可以在9月26日-27日登录注册系统查看是否已被遴选而获得参会资格，并进行参会确认，未确认参会者视为注册无效。</div>
            <div class="info-list">(5). 9月27日~9月29日，组委会将查看确认参会情况。若有更多空余参会名额，将再次从第二次预注册人员中遴选相应数量的可参会者，并邀请其确认参会。</div>
            

             
            <p>感谢大家对VALSE的支持和信任！期待与您在天津相聚，共享视觉与学习年度盛宴！</p>
            <p>VALSE 2022组委会</p>
            <p><b><font color="#000080">附: VALSE2022 VIP定义</font></b></p>
              <div class="info-list not-indent">1.      VALSE指导委员会委员，顾问委员会委员；</div>

              <div class="info-list not-indent">2.      VALSE历届LACC、SACC、EACC委员；</div>

              <div class="info-list not-indent">3.      VALSE历届VODB/VOOC委员；</div>

              <div class="info-list not-indent">4.      VALSE2022全体组委会（含Workshop、APR、宣传等所有的各类主席等）；</div>

              <div class="info-list not-indent">5.      VALSE2022大会讲者(含Workshop讲者、APR讲者、Tutorial讲者)；</div>

              <div class="info-list not-indent">6.      VALSE历届大会主席和PC主席；</div>

              <div class="info-list not-indent">7.      VALSE历届大会讲者、APR讲者和Tutorial讲者；</div>

              <div class="info-list not-indent">8.      本届VALSE大会赞助商权益规定的限定数量赞助商VIP人员。</div> -->
            
            </div>
          </div>
        </div>
      </div>
      <div class="content-item-grp" v-show="false">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">VALSE 2026 关于【第二次预注册】事宜的通知</span>
          </div>
          <div class="item-content reg-info" style="text-align: left;">
            <div class="info-content">
              <!-- <p>
                VALSE 2026 大会（<a href="http://valser.org/2026/" target="_blank" rel="noopener noreferrer" class="reg-link">http://valser.org/2026/</a>）将于<strong>2026年5月8-10日</strong>在<strong>武汉国际会议中心</strong>举办，由中国图象图形学学会主办，华中科技大学、武汉大学和中国地质大学（武汉）承办。<strong>本年 VALSE 大会一如既往的不收注册费。欢迎大家及时报名参加。</strong>
              </p> -->
              <p>预注册地址：<a href="https://valser.org/reg/2026/" target="_blank" rel="noopener noreferrer" class="reg-link">https://valser.org/reg/2026/</a></p>
              <div class="info-list">(1). <strong><font color="#f00000">2026年4月16日 15:00:00</font></strong> 将开放参会预注册。</div>
              <div class="info-list">(2). 注册系统需要通过手机短信进行验证，由于会场要求，<strong><font color="#f00000">请务必填写与您身份证件完全一致的姓名，若注册姓名与证件姓名不一致，</font></strong>届时将无法进入会场参会。</div>
              <div class="info-list">(3). VALSE 2026 大会注册现场将查验身份证件，<strong>确保人、证、注册信息一致方可参会。</strong></div>
              <div class="info-list">(4). 注册信息提交后，需根据系统提示<strong>设置密码</strong>（用于后续登录），并<strong>填写拟参加的 Workshop 和 Tutorial</strong>，以便会务组合理安排会议室，请您提前准备好。（<router-link :to="{ name: 'Workshop' }">点击查看 Workshop 详情</router-link>）</div>
              <div class="info-list">(5). 您参会预注册成功后，<strong>仍需要关注后续确认参会的通知</strong>，该通知将在 VALSE 微信公众号和网站发布。完成正式参会确认，才会被视为成功完成 VALSE 2026 参会注册，未按时完成确认者将无法参会。</div>
              <p><strong>特别提醒：</strong>为保障更多有意参会的老师和同学能够获得名额，参会资格不得转让他人，<strong><font color="#f00000">且预注册成功后，注册手机号、姓名、身份证号等信息将无法修改。</font></strong>如果确认参会后有名额剩余，组委会将根据确认参会人数的情况，适时开放一定数量的参会名额。</p>
              <p class="reg-highlight-tip">预注册成功后，手机号、姓名、身份证号将无法修改，建议您提前准备好，用复制粘贴方式填写。</p>
              <p>感谢大家对 VALSE 的支持和信任！期待与您在武汉相聚，共享视觉与学习年度盛宴！</p>
              <p>VALSE 2026 组委会</p>
              <p class="reg-contact">联系邮箱：<a href="mailto:valse_official@163.com" class="reg-link">valse_official@163.com</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Register"
    }
</script>

<style scoped>
  .program_banner{
    background-image: url("../../static/images/sub_banner/09.jpg");
  }
  .footer{
    /* position: fixed; */
    bottom: 0;
  }
  .text-content-title{
    text-align: center;
    text-indent: 0;
    font-weight: bolder;
  }
  .reg-info p{
    text-indent: 0;
    margin-bottom: 4px;
  }
  .reg-info .not-indent{
    text-indent: 0;
  }
  .info-content{
    text-align: left;
  }
  .info-list{
    margin: 6px 0;
  }
  .info-title{
    font-weight: bolder;
    font-size: 18px;
  }
  .reg-status-line{
    margin-top: 16px;
    color: #f00000;
  }
  .reg-contact{
    margin-top: 8px;
    text-indent: 0;
  }
  .reg-link{
    color: #409EFF;
    word-break: break-all;
  }
  .reg-highlight-tip{
    margin: 14px 0;
    padding: 12px 14px 12px 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.6;
    color: #c0392b;
    background: linear-gradient(90deg, #fff3e0 0%, #fff8f0 100%);
    border-left: 4px solid #e67e22;
    border-radius: 0 6px 6px 0;
    box-shadow: 0 1px 4px rgba(230, 126, 34, 0.15);
  }
  @media screen  and (max-width: 800px){
    .content-item {
      margin: 70px auto;
      margin-bottom: 30px;
    }
    .program_banner{
      /*background-image: url("../../static/images/register-banner.jpg");*/
      background-size: cover;
      background-position: 23% 100%;

    }
    .item-title-content{
      position: relative;
      top:-38px;
    }
    .item-content{
      margin-top: -30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Register.vue